import Icon from '@admin/components/icon'
import T from '@admin/components/t'
import PropTypes from 'prop-types'
import Section from './section'
import React from 'react'
import Page from './page'

class Design extends React.Component {

  static propTypes = {
    components: PropTypes.object,
    config: PropTypes.object,
    onPop: PropTypes.func,
    onPush: PropTypes.func,
    onUpdate: PropTypes.func
  }

  render() {
    const sections = this._getSections()
    return (
      <div className="designer-page-sections">
        { sections.map((section, index) => (
          <div key={`section_${index}`} className="designer-page-section" onClick={ this._handleChoose.bind(this, index) }>
            <div className="designer-page-section-label">
              <T text={ section.label || `Section ${ index }`} />
            </div>
            <div className="designer-page-section-proceed">
              <Icon svg="chevron_right" />
            </div>
          </div>
        ))}
      </div>
    )
  }

  _getSections() {
    return [
      { label: 't(Page)', component: Page, props: this._getPage.bind(this) },
      { label: 't(Header)', component: Section, props: this._getSection.bind(this, 'header', 'Header') },
      { label: 't(Body)', component: Section, props: this._getSection.bind(this, 'body', 'Body') },
      { label: 't(Footer)', component: Section, props: this._getSection.bind(this, 'footer', 'Footer') }
    ]
  }

  _getPage() {
    const { components, config, onPop, onPush, onUpdate } = this.props
    return {
      components,
      config: config.page,
      onPop,
      onPush,
      onUpdate
    }
  }

  _getSection(code, label) {
    const { components, config, onPop, onPush, onUpdate } = this.props
    return {
      code,
      components,
      config: config[code],
      label,
      onPop,
      onPush,
      onUpdate
    }
  }

  _handleChoose(index) {
    const sections = this._getSections()
    const section = sections[index]
    this.props.onPush(section.component, section.props)
  }

}

export default Design
